import "./App.css";
import BrowserComponent from "./components/BrowserComponent";
import Container from "react-bootstrap/Container";
import MobileComponent from "./components/MobileComponent";
import { BrowserRouter } from "react-router-dom";
import { BrowserView, MobileView } from "react-device-detect";

function App() {
  return (
    <BrowserRouter basename="/cph-install/ios/addtohome/">
      <Container fluid className="container">
        <BrowserView>
          <BrowserComponent />
        </BrowserView>
        <MobileView>
          <MobileComponent />
        </MobileView>
      </Container>
    </BrowserRouter>
  );
}

export default App;
